import share from '@src/components/share';
import React from 'react';
import OptionList from './OptionList';
import OptionsPopover from './Options';
import OptionsDropdown from './OptionsDropdown';

export const OptionRenderer = ({
  horizontalLayout,
  sharingState,
  isSavedDashboard,
  savedDashboardCreatorId,
  pageKeyForSaveService,
  id,
  interval,
  savingState,
}) => {
  //checkFeature('trends.base.options_popover', true)
  return horizontalLayout ? (
    <OptionsPopover
      optionRender={
        <OptionList
          sharingState={sharingState}
          isSavedDashboard={isSavedDashboard}
          share={share}
          id={id}
          savedDashboardCreatorId={savedDashboardCreatorId}
          pageKeyForSaveService={pageKeyForSaveService}
          interval={interval}
        />
      }
      pageKeyForSaveService={pageKeyForSaveService}
      savingState={savingState}
    />
  ) : (
    <OptionsDropdown
      pageKeyForSaveService={pageKeyForSaveService}
      sharingState={sharingState}
      isSavedDashboard={isSavedDashboard}
      savingState={savingState}
      share={share}
      id={id}
      savedDashboardCreatorId={savedDashboardCreatorId}
    />
  );
};
